// next
import NextLink from 'next/link';
// @mui
import { styled, alpha } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
// components
import { CustomAvatar } from '../../../components/custom-avatar';
import { fNumberFix } from 'utils/formatNumber';
import { useSelector } from 'redux/store';

// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: alpha(theme.palette.grey[500], 0.12),
  transition: theme.transitions.create('opacity', {
    duration: theme.transitions.duration.shorter,
  }),
}));

// ----------------------------------------------------------------------

export default function NavAccount() {
  const { user } = useSelector((state) => state.global);

  return (
    <NextLink href={PATH_DASHBOARD.user.account} passHref>
      <StyledRoot>
        <CustomAvatar
          src={'/assets/images/avatars/avatar_default.jpg'}
          alt={user?.fullname}
          name={user?.fullname}
        />

        <Box sx={{ ml: 2, minWidth: 0 }}>
          <Typography variant="subtitle2" noWrap>
            {`${user?.firstname ?? ''} ${user?.lastname ?? ''} ${
              user?.permission ? `(Admin)` : ''
            }`}
          </Typography>
          <Typography variant="subtitle2" noWrap>
            {user?.loyal?.displayname}
          </Typography>

          <Typography color={(theme) => theme.palette.primary.main} variant="subtitle2" noWrap>
            {`${fNumberFix(user?.coin ?? 0)} Coin`}
          </Typography>
        </Box>
      </StyledRoot>
    </NextLink>
  );
}
